import { IMapMemory } from '../types/@types/sl-v-types';
import { SLLayer } from './sl-layer';
import { Subject } from 'rxjs';
import { EventEmitter } from '@angular/core';

export class SLMapMemory implements IMapMemory {
	layer: SLLayer = null;
	features: (string | number)[];

	featureCount = 0;
	public changes: EventEmitter<any> = new EventEmitter();
	Clear() {
		this.layer = null;
		this.features = [];
		this.featureCount = 0;
		this.changes.emit(this.featureCount);
	}
	IsMemoryLayer(layer) {
		if (this.layer === null) {
			return false;
		}
		return this.layer === layer;
	}
	IsMemoryLayerId(identifier) {
		if (this.layer === null) {
			return false;
		}
		return this.layer.identifier === identifier;
	}
	MemoryAdd(layer, featureIds): Promise<IMapMemory> {
		return new Promise((resolve, reject) => {
			if (this.layer !== layer) {
				if (this.layer !== null) {
					const args = { layer: (layer), featureIds: (featureIds), reason: 'different layers' };
					reject(args);
					return;
				}
				this.features = [];
			}
			this.layer = layer;
			if (this.features === undefined) {
				this.features = [];
			}
			for (const featureId of featureIds) {
				if (this.features.indexOf(featureId) === -1) {
					this.features.push(featureId);
				}
			}
			this.featureCount = this.features.length;

			this.changes.emit(this.featureCount);
			resolve(this);
		});
	}
	MemoryRemove(layer: SLLayer, featureIds: (string | number)[]): Promise<IMapMemory> {
		return new Promise((resolve, reject) => {
			if (this.layer !== layer) {
				const args = { layer: (layer), featureIds: (featureIds), reason: 'different layers' };
				reject(args);
				return;
			}
			for (const featureId of featureIds) {
				const index = this.features.indexOf(featureId);
				if (index > -1) {
					this.features.splice(index, 1);
				}
			}
			this.featureCount = this.features.length;
			this.changes.emit(this.featureCount);
		});
	}
	IsRememberedFeature(featureId): boolean {
		if (this.features === null) { return false; }
		return this.features.indexOf(featureId) > -1;
	}
}
